import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Mobile-only Sticky-CTA: erscheint nach dem Hero, holt Handy-Besucher am Absprungpunkt ab.
 *  Liegt unter ScrollNav (bottom-24) und wird vor dem Scrollen ausgeblendet, damit Hero & Cookie-Banner frei bleiben. */
export const StickyTestCta = () => {
  const [show, setShow] = useState(false);
  // Solange die Cookie-Entscheidung aussteht, dockt der CTA oberhalb des Banners an – nie Überlappung.
  const [cookiePending, setCookiePending] = useState(() => {
    try { return !localStorage.getItem("dimedial-cookie-info-seen"); } catch { return false; }
  });
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    const h = () => setCookiePending(false);
    window.addEventListener("cookie-hint-dismissed", h);
    return () => window.removeEventListener("cookie-hint-dismissed", h);
  }, []);
  return (
    <div
      className={`md:hidden fixed inset-x-0 bottom-0 z-[54] px-3 pt-2 pb-[calc(0.75rem_+_env(safe-area-inset-bottom))] transition-[transform,margin] duration-300 ${show ? "translate-y-0" : "translate-y-[150%] pointer-events-none"} ${show && cookiePending ? "mb-[5rem]" : "mb-0"}`}
      aria-hidden={!show}
      data-testid="sticky-test-cta">
      <Link
        to="/kunden/registrieren"
        tabIndex={show ? 0 : -1}
        className="flex items-center justify-between gap-3 rounded-full bg-[#FDD105] px-5 py-3 shadow-[0_14px_34px_-10px_rgba(0,0,0,0.4)]"
        data-testid="sticky-test-cta-link">
        <span className="min-w-0">
          <span className="block font-bold text-sm leading-none text-[#111]">30 Tage kostenlos testen</span>
          <span className="mt-1.5 block text-[10px] leading-none text-[#111]/70">Ohne Zahlungsdaten · seit 2000 in Herford</span>
        </span>
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#111] text-[#FDD105]">
          <ArrowRight size={18} aria-hidden="true" />
        </span>
      </Link>
    </div>
  );
};
